export default function PHP_poll() {
  return (
    <div>
      <h1>PHP_poll</h1>
    </div>
  );
}
